// Small presentation helpers shared across screens. No business logic — the
// backend owns all real computation (online windows, metric aggregation, etc.).

export function relativeTime(ts?: number | null): string {
  if (ts == null) return "never";
  const delta = Date.now() - ts;
  if (delta < 0) return "just now";
  const s = Math.floor(delta / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

export function absoluteTime(ts?: number | null): string {
  if (ts == null) return "—";
  return new Date(ts).toLocaleString();
}

export function pct(n: number, total: number): string {
  if (total <= 0) return "—";
  return `${((n / total) * 100).toFixed(1)}%`;
}

export function ms(n?: number | null): string {
  if (n == null) return "—";
  return `${Math.round(n)} ms`;
}

// Format a 0..1 fraction as a percentage (the backend returns rates as
// fractions of `labeled`). null -> em dash.
export function pct01(frac?: number | null): string {
  if (frac == null) return "—";
  return `${(frac * 100).toFixed(1)}%`;
}

// Detections-per-hour frequency. null -> em dash.
export function perHour(n?: number | null): string {
  if (n == null) return "—";
  if (n >= 100) return `${Math.round(n)}/h`;
  return `${n.toFixed(1)}/h`;
}

// Short, stable id suffix for display (the full Convex id is long + opaque).
export function shortId(id: string): string {
  return id.length > 8 ? `…${id.slice(-6)}` : id;
}
